import{t,getLocale,applyStaticI18n}from'../i18n/index.js?v=20260727-atlas-guide-3';
import{SESSION_HANDOFF_DECISIONS,classifySessionState,isSessionConflictError,sessionGeneration}from'../session-handoff-core.mjs';
import{TURNSTILE_SITE_KEY,FALLBACK_RULES}from'../net/config.js';
import{consumePasswordRecoverySession,createAccount,currentAdminContext,currentProfile,currentRules,currentSession,currentWallet,getClientSessionState,onAccountChange,requestPasswordReset,resendSignupConfirmation,signInAccount,signOutAccount,signupEmailStatus,takeoverClientSession,trainerNameAvailable,updateAccountPassword,verifyEmailToken,claimClientSession}from'../net/supabase-client.js?v=20260801-token-hash-1';

const $=selector=>document.querySelector(selector);
// Tipos aceitos em ?type= nos links próprios (templates de e-mail do Supabase).
const TOKEN_HASH_TYPES=['signup','email','recovery','invite','magiclink','email_change'];
const RETURNING_KEY='idlemon-returning';
function markReturning(){try{localStorage.setItem(RETURNING_KEY,'1')}catch{}}
function hasReturned(){try{return localStorage.getItem(RETURNING_KEY)==='1'}catch{return false}}
function preserveRecoveryCallback(){
  const url=new URL(location.href);
  url.searchParams.delete('code');
  url.searchParams.set('auth','recovery');
  const safeHash=url.hash.includes('type=recovery')?'':url.hash;
  history.replaceState({},document.title,`${url.pathname}${url.search}${safeHash}`);
}
let rules=structuredClone(FALLBACK_RULES);
let mode='register';
let settled=false;
let recoveryMode=false;
const captcha={register:{token:'',widget:null},login:{token:'',widget:null},forgot:{token:'',widget:null}};

function setStatus(message='',kind='error'){
  const el=$('#accountStatus');
  if(!el)return;
  el.textContent=message;
  el.className=`account-status ${message?'':'hidden'} ${kind}`;
}

function setBusy(busy){
  $$('#accountScreen button,#accountScreen input').forEach(el=>el.disabled=busy);
  $('#accountScreen')?.classList.toggle('is-busy',busy);
}

function $$(selector){return[...document.querySelectorAll(selector)]}

function setMode(next){
  mode=['login','forgot','recovery'].includes(next)?next:'register';
  $$('.account-tab').forEach(button=>{
    const active=button.dataset.accountMode===(mode==='forgot'?'login':mode);
    button.classList.toggle('active',active);
    button.setAttribute('aria-selected',String(active));
  });
  $('#registerForm')?.classList.toggle('hidden',mode!=='register');
  $('#loginForm')?.classList.toggle('hidden',mode!=='login');
  $('#forgotPasswordForm')?.classList.toggle('hidden',mode!=='forgot');
  $('#updatePasswordForm')?.classList.toggle('hidden',mode!=='recovery');
  $('.account-tabs')?.classList.toggle('hidden',mode==='recovery');
  setStatus();
  if(mode==='register'||mode==='login'||mode==='forgot')resetCaptcha(mode);
}

function ensureRecoveryForms(){
  const loginForm=$('#loginForm');
  const status=$('#accountStatus');
  if(!loginForm||!status||$('#forgotPasswordForm'))return;
  const forgotButton=document.createElement('button');
  forgotButton.type='button';
  forgotButton.className='account-link';
  forgotButton.dataset.accountMode='forgot';
  forgotButton.dataset.i18n='auth.forgotPassword';
  forgotButton.textContent=t('auth.forgotPassword');
  loginForm.querySelector('.account-submit')?.before(forgotButton);

  const wrapper=document.createElement('div');
  wrapper.innerHTML=`
    <form class="account-form hidden" id="forgotPasswordForm" novalidate>
      <p class="account-form-copy" data-i18n="auth.resetIntro"></p>
      <label class="account-field">
        <span data-i18n="auth.email"></span>
        <input name="email" type="email" autocomplete="email" inputmode="email" required data-i18n-placeholder="auth.emailPlaceholder" />
      </label>
      <div class="account-captcha hidden" id="forgotCaptcha"></div>
      <button type="submit" class="account-submit" data-i18n="auth.sendReset"></button>
      <button type="button" class="account-link" data-account-mode="login" data-i18n="auth.backToLogin"></button>
    </form>
    <form class="account-form hidden" id="updatePasswordForm" novalidate>
      <p class="account-form-copy" data-i18n="auth.newPasswordIntro"></p>
      <div class="account-password-grid">
        <label class="account-field">
          <span data-i18n="auth.newPassword"></span>
          <input name="password" type="password" minlength="8" autocomplete="new-password" required data-i18n-placeholder="auth.passwordPlaceholder" />
        </label>
        <label class="account-field">
          <span data-i18n="auth.passwordConfirmation"></span>
          <input name="passwordConfirmation" type="password" minlength="8" autocomplete="new-password" required data-i18n-placeholder="auth.passwordConfirmationPlaceholder" />
        </label>
      </div>
      <button type="submit" class="account-submit" data-i18n="auth.saveNewPassword"></button>
    </form>`;
  const forms=[...wrapper.children];
  status.before(...forms);
  forms.forEach(form=>applyStaticI18n(form));
}

function renderRules(){
  const title=$('#rulesTitle'),version=$('#rulesVersion'),list=$('#rulesSummary');
  const localized=rules.content?.[getLocale()]||rules.content?.['pt-BR']||rules;
  if(title)title.textContent=localized.title||t('auth.rulesTitle');
  if(version)version.textContent=t(rules.status==='draft'?'auth.rulesDraftVersion':'auth.rulesVersion',{version:rules.version});
  if(list)list.innerHTML=(localized.summary||[]).map(item=>`<li>${escapeHtml(item)}</li>`).join('');
  $$('.account-rules-version').forEach(el=>el.textContent=rules.version||FALLBACK_RULES.version);
}

function escapeHtml(value){
  return String(value??'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
}

// Link de e-mail vencido/queimado: o GoTrue devolve otp_expired tanto no erro
// do verifyOtp quanto no redirect (?error_code=... ou #error_code=...).
function isExpiredLink(error){
  const raw=String(error?.message||error?.error_description||error||'').toLowerCase();
  if(error?.code==='otp_expired')return true;
  return raw.includes('otp_expired')
    ||raw.includes('link has expired')
    ||raw.includes('invalid or has expired')
    ||(raw.includes('token')&&raw.includes('expired'));
}

function friendlyError(error){
  const raw=String(error?.message||error?.error_description||error||'').toLowerCase();
  if(error?.code==='email_address_invalid'||raw.includes('email address')&&raw.includes('invalid'))return t('auth.errorEmail');
  if(raw.includes('trainer_name_unavailable')||raw.includes('already taken'))return t('auth.errorNameUnavailable');
  if(raw.includes('invalid_trainer_name'))return t('auth.errorNameInvalid');
  if(raw.includes('rules_acceptance_required'))return t('auth.errorRules');
  if(raw.includes('already registered')||raw.includes('user already exists'))return t('auth.errorEmailExists');
  if(error?.code==='over_email_send_rate_limit'||raw.includes('email rate limit'))return t('auth.errorEmailRate');
  if(raw.includes('invalid login credentials'))return t('auth.errorCredentials');
  if(raw.includes('over_request_rate_limit')||raw.includes('rate_limited'))return t('auth.errorLoginRate');
  if(raw.includes('email not confirmed'))return t('auth.errorEmailUnconfirmed');
  if(error?.code==='user_banned'||raw.includes('user is banned'))return t('auth.errorUserBanned');
  if(error?.code==='signup_disabled'||raw.includes('signups not allowed'))return t('auth.errorSignupDisabled');
  if(error?.code==='same_password'||raw.includes('should be different from the old password'))return t('auth.errorSamePassword');
  if(raw.includes('profile_not_found'))return t('auth.errorProfileMissing');
  if(raw.includes('session_conflict_kept'))return t('auth.sessionConflictKept');
  if(raw.includes('session_conflict_changed'))return t('auth.sessionConflictChanged');
  if(raw.includes('session_conflict'))return t('auth.sessionConflict');
  if(isExpiredLink(error))return t('auth.errorLinkExpired');
  if(raw.includes('captcha')||raw.includes('turnstile'))return t('auth.errorCaptcha');
  if(raw.includes('too many accounts'))return t('auth.errorIpLimit');
  if(raw.includes('database error'))return t('auth.errorServerInternal');
  if(error?.code==='email_address_not_authorized'||(raw.includes('error sending')&&raw.includes('email'))||(raw.includes('email address')&&raw.includes('not authorized')))return t('auth.errorEmailSend');
  if(error?.code==='weak_password'||(raw.includes('password')&&(raw.includes('weak')||raw.includes('easy to guess')))||raw.includes('password should'))return t('auth.errorPasswordWeak');
  if(raw.includes('failed to fetch')||raw.includes('network'))return t('auth.errorNetwork');
  return t('auth.errorGeneric');
}

const EMAIL_PATTERN=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const nameCheck={timer:0,seq:0};

function setFieldCheck(selector,state='',symbol=''){
  const el=$(selector);
  if(!el)return;
  el.className=`field-check ${state}`;
  el.textContent=symbol;
}

function setNameFeedback(message='',kind=''){
  const el=$('#registerNameFeedback');
  if(!el)return;
  el.textContent=message;
  el.className=`account-field-feedback ${message?'':'hidden'} ${kind}`;
}

function validateEmailField(){
  const input=$('#registerForm')?.elements.email;
  const value=String(input?.value||'').trim();
  if(!value){setFieldCheck('#registerEmailCheck');return}
  const ok=EMAIL_PATTERN.test(value)&&input.checkValidity();
  setFieldCheck('#registerEmailCheck',ok?'ok':'bad',ok?'✓':'✕');
}

function validateNameField(){
  const value=String($('#registerTrainerName')?.value||'').trim();
  clearTimeout(nameCheck.timer);
  const seq=++nameCheck.seq;
  if(!value){setFieldCheck('#registerNameCheck');setNameFeedback();return}
  if(!/^[A-Za-z0-9_]{3,16}$/.test(value)){
    setFieldCheck('#registerNameCheck','bad','✕');
    setNameFeedback(t('auth.errorNameInvalid'),'bad');
    return;
  }
  setFieldCheck('#registerNameCheck','checking','…');
  setNameFeedback(t('auth.checkingName'));
  nameCheck.timer=setTimeout(async()=>{
    try{
      const available=await trainerNameAvailable(value);
      if(seq!==nameCheck.seq)return;
      setFieldCheck('#registerNameCheck',available?'ok':'bad',available?'✓':'✕');
      setNameFeedback(available?t('auth.nameAvailable'):t('auth.errorNameUnavailable'),available?'ok':'bad');
    }catch{
      if(seq!==nameCheck.seq)return;
      setFieldCheck('#registerNameCheck');
      setNameFeedback();
    }
  },450);
}

function validRegistration(form){
  const email=String(form.elements.email.value||'').trim();
  const trainerName=String(form.elements.trainerName.value||'').trim();
  const password=String(form.elements.password.value||'');
  const confirmation=String(form.elements.passwordConfirmation.value||'');
  if(!email||!EMAIL_PATTERN.test(email)||!form.elements.email.checkValidity()){setStatus(t('auth.errorEmail'));return null}
  if(!/^[A-Za-z0-9_]{3,16}$/.test(trainerName)){setStatus(t('auth.errorNameInvalid'));return null}
  if(password.length<8){setStatus(t('auth.errorPassword'));return null}
  if(password!==confirmation){setStatus(t('auth.errorPasswordMatch'));return null}
  if(!form.elements.rulesAccepted.checked){setStatus(t('auth.errorRules'));return null}
  if(TURNSTILE_SITE_KEY&&!captcha.register.token){setStatus(t('auth.errorCaptcha'));return null}
  return{email,trainerName,password};
}

function requestSessionConflictDecision(){
  return new Promise(resolve=>{
    const overlay=document.createElement('div');
    overlay.className='game-confirm session-conflict-dialog';
    overlay.setAttribute('role','dialog');
    overlay.setAttribute('aria-modal','true');
    const card=document.createElement('div');
    card.className='game-confirm-card session-conflict-card';
    const eyebrow=document.createElement('span');
    eyebrow.className='eyebrow';
    eyebrow.textContent=t('auth.sessionConflictEyebrow');
    const title=document.createElement('h2');
    title.textContent=t('auth.sessionConflictTitle');
    const body=document.createElement('p');
    body.textContent=t('auth.sessionConflictBody');
    const note=document.createElement('p');
    note.className='session-conflict-note';
    note.textContent=t('auth.sessionConflictNote');
    const actions=document.createElement('div');
    actions.className='game-confirm-actions session-conflict-actions';
    const keep=document.createElement('button');
    keep.type='button';
    keep.className='ui-btn';
    keep.textContent=t('auth.sessionConflictKeep');
    const takeover=document.createElement('button');
    takeover.type='button';
    takeover.className='ui-btn-primary';
    takeover.textContent=t('auth.sessionConflictTakeover');
    actions.append(keep,takeover);
    card.append(eyebrow,title,body,note,actions);
    overlay.append(card);
    document.body.append(overlay);

    let settledDecision=false;
    const finish=decision=>{
      if(settledDecision)return;
      settledDecision=true;
      removeEventListener('keydown',onKeyDown);
      overlay.remove();
      resolve(decision);
    };
    const onKeyDown=event=>{
      if(event.key==='Escape'){
        event.preventDefault();
        finish(SESSION_HANDOFF_DECISIONS.KEEP_EXISTING);
      }
    };
    keep.addEventListener('click',()=>finish(SESSION_HANDOFF_DECISIONS.KEEP_EXISTING));
    takeover.addEventListener('click',()=>finish(SESSION_HANDOFF_DECISIONS.TAKEOVER));
    overlay.addEventListener('click',event=>{
      if(event.target===overlay)finish(SESSION_HANDOFF_DECISIONS.KEEP_EXISTING);
    });
    addEventListener('keydown',onKeyDown);
    keep.focus();
  });
}

async function claimSessionWithDecision(){
  for(let attempt=0;attempt<3;attempt++){
    try{return await claimClientSession()}
    catch(error){
      if(!isSessionConflictError(error))throw error;
      const status=await getClientSessionState();
      if(classifySessionState(status)!=='conflict')continue;
      const generation=sessionGeneration(status);
      if(generation===null)throw new Error('session_conflict_changed');
      const decision=await requestSessionConflictDecision();
      if(decision===SESSION_HANDOFF_DECISIONS.KEEP_EXISTING){
        try{await signOutAccount({scope:'local'})}catch{}
        throw new Error('session_conflict_kept');
      }
      try{return await takeoverClientSession(generation)}
      catch(takeoverError){
        if(isSessionConflictError(takeoverError)&&attempt<2)continue;
        throw takeoverError;
      }
    }
  }
  throw new Error('session_conflict_changed');
}

async function accountPayload(session){
  await claimSessionWithDecision();
  const[profile,wallet]=await Promise.all([
    currentProfile(session.user.id),
    currentWallet(session.user.id),
  ]);
  if(!profile)throw new Error('profile_not_found');
  let admin={is_admin:false,role:'player',capabilities:[]};
  try{admin=await currentAdminContext()}catch(error){console.warn('admin context unavailable',error)}
  return{session,profile,wallet,admin};
}

function complete(resolve,payload){
  if(settled)return;
  settled=true;
  $('#accountScreen')?.classList.add('hidden');
  resolve(payload);
}

async function submitRegistration(event,resolve){
  event.preventDefault();
  const form=event.currentTarget;
  const values=validRegistration(form);
  if(!values)return;
  setBusy(true);setStatus(t('auth.creating'),'info');
  try{
    const emailStatus=await signupEmailStatus(values.email);
    if(emailStatus==='active'){
      markReturning();
      setStatus(t('auth.errorEmailExists'));
      return;
    }
    if(emailStatus==='pending'){
      await resendSignupConfirmation({
        email:values.email,
        captchaToken:captcha.register.token||undefined,
      });
      resetCaptcha('register');
      markReturning();
      setStatus(t('auth.emailPendingActivation',{email:values.email}),'info');
      return;
    }
    const available=await trainerNameAvailable(values.trainerName);
    if(!available){setStatus(t('auth.errorNameUnavailable'));return}
    const data=await createAccount({
      ...values,
      rulesVersion:rules.version,
      captchaToken:captcha.register.token||undefined,
    });
    resetCaptcha('register');
    markReturning();
    if(data.session){
      complete(resolve,await accountPayload(data.session));
      return;
    }
    form.reset();
    validateEmailField();
    validateNameField();
    setStatus(t('auth.confirmationSent',{email:values.email}),'success');
  }catch(error){
    console.error('account signup failed',error);
    resetCaptcha('register');
    setStatus(friendlyError(error));
  }finally{setBusy(false)}
}

async function submitLogin(event,resolve){
  event.preventDefault();
  const form=event.currentTarget;
  const identifier=String(form.elements.identifier.value||'').trim();
  const password=String(form.elements.password.value||'');
  if(!identifier||!password){setStatus(t('auth.errorCredentials'));return}
  if(TURNSTILE_SITE_KEY&&!captcha.login.token){setStatus(t('auth.errorCaptcha'));return}
  setBusy(true);setStatus(t('auth.entering'),'info');
  try{
    const data=await signInAccount({identifier,password,captchaToken:captcha.login.token||undefined});
    resetCaptcha('login');
    markReturning();
    complete(resolve,await accountPayload(data.session));
  }catch(error){
    console.error('account login failed',error);
    resetCaptcha('login');
    setStatus(friendlyError(error));
  }finally{setBusy(false)}
}

async function submitPasswordReset(event){
  event.preventDefault();
  const form=event.currentTarget;
  const email=String(form.elements.email.value||'').trim();
  if(!email||!form.elements.email.checkValidity()){setStatus(t('auth.errorEmail'));return}
  if(TURNSTILE_SITE_KEY&&!captcha.forgot.token){setStatus(t('auth.errorCaptcha'));return}
  setBusy(true);setStatus(t('auth.sendingReset'),'info');
  try{
    await requestPasswordReset(email,captcha.forgot.token||undefined);
    resetCaptcha('forgot');
    form.reset();
    setStatus(t('auth.resetSent'),'success');
  }catch(error){
    console.error('password reset request failed',error);
    resetCaptcha('forgot');
    setStatus(friendlyError(error));
  }finally{setBusy(false)}
}

async function submitNewPassword(event){
  event.preventDefault();
  const form=event.currentTarget;
  const password=String(form.elements.password.value||'');
  const confirmation=String(form.elements.passwordConfirmation.value||'');
  if(password.length<8){setStatus(t('auth.errorPassword'));return}
  if(password!==confirmation){setStatus(t('auth.errorPasswordMatch'));return}
  setBusy(true);setStatus(t('auth.savingPassword'),'info');
  try{
    await updateAccountPassword(password);
    await signOutAccount();
    recoveryMode=false;
    history.replaceState({},document.title,location.pathname);
    form.reset();
    setMode('login');
    setStatus(t('auth.passwordUpdated'),'success');
  }catch(error){
    console.error('password update failed',error);
    setStatus(friendlyError(error));
  }finally{setBusy(false)}
}

function resetCaptcha(kind){
  captcha[kind].token='';
  if(captcha[kind].widget!==null&&globalThis.turnstile)globalThis.turnstile.reset(captcha[kind].widget);
}

function loadTurnstile(){
  if(!TURNSTILE_SITE_KEY)return Promise.resolve();
  if(globalThis.turnstile)return Promise.resolve();
  return new Promise((resolve,reject)=>{
    const existing=document.querySelector('script[data-idlemon-turnstile]');
    if(existing){existing.addEventListener('load',resolve,{once:true});existing.addEventListener('error',reject,{once:true});return}
    const script=document.createElement('script');
    script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async=true;script.defer=true;script.dataset.idlemonTurnstile='';
    script.onload=resolve;script.onerror=reject;document.head.append(script);
  });
}

async function renderCaptcha(){
  if(!TURNSTILE_SITE_KEY)return;
  try{
    await loadTurnstile();
    for(const kind of ['register','login','forgot']){
      const host=$(`#${kind}Captcha`);
      if(!host||captcha[kind].widget!==null)continue;
      host.classList.remove('hidden');
      captcha[kind].widget=globalThis.turnstile.render(host,{
        sitekey:TURNSTILE_SITE_KEY,
        theme:'dark',
        callback:token=>captcha[kind].token=token,
        'expired-callback':()=>captcha[kind].token='',
        'error-callback':()=>captcha[kind].token='',
      });
    }
  }catch(error){console.error('turnstile load failed',error);setStatus(t('auth.errorCaptcha'))}
}

function wire(resolve){
  ensureRecoveryForms();
  const screen=$('#accountScreen');
  screen?.addEventListener('click',event=>{
    const button=event.target.closest('[data-account-mode]');
    if(!button||!screen.contains(button)||button.disabled)return;
    event.preventDefault();
    setMode(button.dataset.accountMode);
  });
  $('#registerForm')?.addEventListener('submit',event=>submitRegistration(event,resolve));
  $('#loginForm')?.addEventListener('submit',event=>submitLogin(event,resolve));
  $('#forgotPasswordForm')?.addEventListener('submit',submitPasswordReset);
  $('#updatePasswordForm')?.addEventListener('submit',submitNewPassword);
  $('#rulesOpen')?.addEventListener('click',()=>$('#rulesDialog')?.classList.remove('hidden'));
  $('#rulesDialogClose')?.addEventListener('click',()=>$('#rulesDialog')?.classList.add('hidden'));
  $('#rulesDialog')?.addEventListener('click',event=>{if(event.target===$('#rulesDialog'))$('#rulesDialog').classList.add('hidden')});
  $('#registerForm')?.elements.email?.addEventListener('input',validateEmailField);
  $('#registerTrainerName')?.addEventListener('input',validateNameField);
}

async function refreshRules(){
  try{rules=await currentRules()}catch(error){console.warn('rules load failed',error)}
  renderRules();
}

async function restoreSession(resolve,preview){
  if(preview==='auth'||preview==='auth-login')return;
  setStatus(t('auth.loading'),'info');
  try{
    const session=await currentSession();
    if(recoveryMode)return;
    if(session){complete(resolve,await accountPayload(session));return}
    setStatus();
  }catch(error){
    console.error('account bootstrap failed',error);
    setStatus(t('auth.errorBackend'));
  }
}

export async function initAccountGate({suggestedTrainerName=''}={}){
  const input=$('#registerTrainerName');
  if(input)input.value=/^[A-Za-z0-9_]{3,16}$/.test(suggestedTrainerName)?suggestedTrainerName:'';
  if(input?.value)validateNameField();
  renderRules();
  const preview=new URLSearchParams(location.search).get('preview');
  if(preview==='auth-login')setMode('login');
  else if(preview==='auth')setMode('register');
  else setMode(hasReturned()?'login':'register');

  return new Promise(resolve=>{
    wire(resolve);
    let recoveryEventSeen=false;
    onAccountChange(event=>{
      if(event!=='PASSWORD_RECOVERY')return;
      recoveryEventSeen=true;
      recoveryMode=true;
      setMode('recovery');
      setStatus(t('auth.recoveryReady'),'info');
    });
    void refreshRules();
    void renderCaptcha();
    const params=new URLSearchParams(location.search);
    const callbackHash=new URLSearchParams(location.hash.replace(/^#/,''));
    const callbackType=callbackHash.get('type');
    // Link próprio (?token_hash=…&type=…) e link legado do /verify convivem: o
    // primeiro é validado aqui, o segundo já chega com a sessão no hash.
    const tokenHash=params.get('token_hash')||'';
    const tokenType=TOKEN_HASH_TYPES.includes(params.get('type'))?params.get('type'):'';
    const recoveryToken=tokenType==='recovery';
    const explicitRecovery=params.get('auth')==='recovery'||callbackType==='recovery'||recoveryToken;
    const explicitConfirmation=(params.get('auth')==='confirm'||callbackType==='signup'||!!tokenType)&&!recoveryToken;
    const confirmCallback=params.has('code')&&!explicitRecovery||explicitConfirmation;
    const callbackUrl=params.has('code')||explicitRecovery||explicitConfirmation;
    void(async()=>{
      // Erro devolvido pelo próprio GoTrue no redirect (link vencido, por ex.).
      const redirectError=params.get('error_code')||params.get('error_description')||params.get('error')
        ||callbackHash.get('error_code')||callbackHash.get('error_description')||callbackHash.get('error')||'';
      let callbackFailure=redirectError
        ?(isExpiredLink(redirectError)
          ?t(explicitRecovery?'auth.errorRecoveryExpired':'auth.errorLinkExpired')
          :friendlyError(redirectError))
        :'';
      if(tokenHash&&tokenType&&!callbackFailure){
        setStatus(t(recoveryToken?'auth.verifyingRecovery':'auth.verifyingEmail'),'info');
        try{
          await verifyEmailToken({tokenHash,type:tokenType});
        }catch(error){
          console.error('email token verification failed',error);
          callbackFailure=isExpiredLink(error)
            ?t(recoveryToken?'auth.errorRecoveryExpired':'auth.errorLinkExpired')
            :friendlyError(error);
        }
        // O token é de uso único: some da URL para não vazar em histórico/share.
        const cleaned=new URL(location.href);
        cleaned.searchParams.delete('token_hash');
        cleaned.searchParams.delete('type');
        cleaned.searchParams.set('auth',recoveryToken?'recovery':'confirm');
        history.replaceState({},document.title,`${cleaned.pathname}${cleaned.search}`);
      }
      if(callbackFailure){
        recoveryMode=false;
        markReturning();
        history.replaceState({},document.title,location.pathname);
        setMode('login');
        setStatus(callbackFailure);
        return;
      }
      // getSession aguarda a inicialização PKCE do cliente. Nesse intervalo o
      // listener instalado no módulo de rede preserva PASSWORD_RECOVERY, mesmo
      // que a UI ainda não estivesse pronta quando o evento foi emitido.
      const callbackSession=callbackUrl?await currentSession():null;
      const recoveredSession=consumePasswordRecoverySession();
      if(recoveryEventSeen||recoveredSession||explicitRecovery&&callbackSession){
        if(!callbackSession&&!recoveredSession){
          recoveryMode=false;
          setMode('login');
          setStatus(t('auth.errorRecoveryExpired'));
          return;
        }
        recoveryMode=true;
        markReturning();
        preserveRecoveryCallback();
        setMode('recovery');
        setStatus(t('auth.recoveryReady'),'info');
        return;
      }
      if(explicitRecovery){
        recoveryMode=false;
        setMode('login');
        setStatus(t('auth.errorRecoveryExpired'));
        return;
      }
      if(confirmCallback){
        if(!callbackSession){
          markReturning();
          history.replaceState({},document.title,location.pathname);
          setMode('login');
          setStatus(t('auth.errorLinkExpired'));
          return;
        }
        // Fluxo PKCE loga automaticamente ao confirmar; forçamos a tela de login.
        try{await signOutAccount()}catch{}
        markReturning();
        history.replaceState({},document.title,location.pathname);
        setMode('login');
        setStatus(t('auth.emailConfirmed'),'success');
        return;
      }
      await restoreSession(resolve,preview);
    })().finally(()=>{
      // Sem sessão restaurada a tela de conta assume: o splash sai de cena.
      if(!settled)globalThis.IdlemonBoot?.finish();
    });
  });
}
